document.addEventListener("DOMContentLoaded", function() {
  var endlessScroll = new Ajaxinate({
    container: '.blog-articles',
    pagination: '#Huratips-Pagination',
    method: 'click'
  });
});

$(document).ready(function(){
  $('.itgv-imageMulticolumn_slider').slick({
    dots: true,
    infinite: false,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows:true,
    prevArrow:'<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M1.2002 6L7.2002 12L7.8002 11.4L2.4002 6L7.8002 0.6L7.2002 0L1.2002 6Z" fill="black"/><path d="M1.2002 6L7.2002 12L7.8002 11.4L2.4002 6L7.8002 0.6L7.2002 0L1.2002 6Z" fill="black" fill-opacity="0.2"/><path d="M1.2002 6L7.2002 12L7.8002 11.4L2.4002 6L7.8002 0.6L7.2002 0L1.2002 6Z" fill="black" fill-opacity="0.2"/><path d="M1.2002 6L7.2002 12L7.8002 11.4L2.4002 6L7.8002 0.6L7.2002 0L1.2002 6Z" fill="black" fill-opacity="0.2"/><path d="M1.2002 6L7.2002 12L7.8002 11.4L2.4002 6L7.8002 0.6L7.2002 0L1.2002 6Z" fill="black" fill-opacity="0.2"/><path d="M1.2002 6L7.2002 12L7.8002 11.4L2.4002 6L7.8002 0.6L7.2002 0L1.2002 6Z" fill="black" fill-opacity="0.2"/></svg></button>',
    nextArrow:'<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M10.7998 6L4.7998 12L4.1998 11.4L9.5998 6L4.1998 0.6L4.7998 0L10.7998 6Z" fill="white"/></svg></button>',
    responsive: [
      {
        breakpoint: 990,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: false
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false
        }
      }
    ]
  });

  // $(document).trigger('click');


  $('.itgv--featuredCollectionSlider .product-grid').slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows:true,
    prevArrow:'<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M1.2002 6L7.2002 12L7.8002 11.4L2.4002 6L7.8002 0.6L7.2002 0L1.2002 6Z" fill="black"/><path d="M1.2002 6L7.2002 12L7.8002 11.4L2.4002 6L7.8002 0.6L7.2002 0L1.2002 6Z" fill="black" fill-opacity="0.2"/><path d="M1.2002 6L7.2002 12L7.8002 11.4L2.4002 6L7.8002 0.6L7.2002 0L1.2002 6Z" fill="black" fill-opacity="0.2"/><path d="M1.2002 6L7.2002 12L7.8002 11.4L2.4002 6L7.8002 0.6L7.2002 0L1.2002 6Z" fill="black" fill-opacity="0.2"/><path d="M1.2002 6L7.2002 12L7.8002 11.4L2.4002 6L7.8002 0.6L7.2002 0L1.2002 6Z" fill="black" fill-opacity="0.2"/><path d="M1.2002 6L7.2002 12L7.8002 11.4L2.4002 6L7.8002 0.6L7.2002 0L1.2002 6Z" fill="black" fill-opacity="0.2"/></svg></button>',
    nextArrow:'<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M10.7998 6L4.7998 12L4.1998 11.4L9.5998 6L4.1998 0.6L4.7998 0L10.7998 6Z" fill="white"/></svg></button>',
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 990,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: false,
          dots: true
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: false,
          dots: true
        }
      }
    ]
  });



  $('.image-productSlider_productMain').slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows:true,
    prevArrow:'<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M1.2002 6L7.2002 12L7.8002 11.4L2.4002 6L7.8002 0.6L7.2002 0L1.2002 6Z" fill="black"/><path d="M1.2002 6L7.2002 12L7.8002 11.4L2.4002 6L7.8002 0.6L7.2002 0L1.2002 6Z" fill="black" fill-opacity="0.2"/><path d="M1.2002 6L7.2002 12L7.8002 11.4L2.4002 6L7.8002 0.6L7.2002 0L1.2002 6Z" fill="black" fill-opacity="0.2"/><path d="M1.2002 6L7.2002 12L7.8002 11.4L2.4002 6L7.8002 0.6L7.2002 0L1.2002 6Z" fill="black" fill-opacity="0.2"/><path d="M1.2002 6L7.2002 12L7.8002 11.4L2.4002 6L7.8002 0.6L7.2002 0L1.2002 6Z" fill="black" fill-opacity="0.2"/><path d="M1.2002 6L7.2002 12L7.8002 11.4L2.4002 6L7.8002 0.6L7.2002 0L1.2002 6Z" fill="black" fill-opacity="0.2"/></svg></button>',
    nextArrow:'<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M10.7998 6L4.7998 12L4.1998 11.4L9.5998 6L4.1998 0.6L4.7998 0L10.7998 6Z" fill="white"/></svg></button>'
  });


    if(window.matchMedia("(max-width: 989px)").matches){
      $('.itgv--iconList_main').slick({
        dots: false,
        infinite: false,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows:true,
        prevArrow:'<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M1.2002 6L7.2002 12L7.8002 11.4L2.4002 6L7.8002 0.6L7.2002 0L1.2002 6Z" fill="black"/><path d="M1.2002 6L7.2002 12L7.8002 11.4L2.4002 6L7.8002 0.6L7.2002 0L1.2002 6Z" fill="black" fill-opacity="0.2"/><path d="M1.2002 6L7.2002 12L7.8002 11.4L2.4002 6L7.8002 0.6L7.2002 0L1.2002 6Z" fill="black" fill-opacity="0.2"/><path d="M1.2002 6L7.2002 12L7.8002 11.4L2.4002 6L7.8002 0.6L7.2002 0L1.2002 6Z" fill="black" fill-opacity="0.2"/><path d="M1.2002 6L7.2002 12L7.8002 11.4L2.4002 6L7.8002 0.6L7.2002 0L1.2002 6Z" fill="black" fill-opacity="0.2"/><path d="M1.2002 6L7.2002 12L7.8002 11.4L2.4002 6L7.8002 0.6L7.2002 0L1.2002 6Z" fill="black" fill-opacity="0.2"/></svg></button>',
        nextArrow:'<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M10.7998 6L4.7998 12L4.1998 11.4L9.5998 6L4.1998 0.6L4.7998 0L10.7998 6Z" fill="white"/></svg></button>',
        responsive: [
          {
            breakpoint: 990,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              arrows: false,
              dots: true
            }
          },
          {
            breakpoint: 750,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              arrows: false,
              dots: true
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: false,
              dots: true
            }
          }
        ]
      });
    }


  $(".imageAndTextMain .button_linkStyle").on('click', function(event) { 
      event.preventDefault(); 
    var buttonUrl = $(this).attr('href');
    $('html, body').animate({
      // scrollTop: eval($(buttonUrl).offset().top - 140)
        scrollTop: $(buttonUrl).offset().top
    }, 1000);
      
  });


  /*Custom tab*/
  
   $(document).on('click', '.tab_custom', function(){
        $(this).addClass('active').siblings().removeClass('active');
      var Input = $(this).find('.tab_button').attr('data-id');
      //alert(Input);
      $('.itgv--main__content').each(function(){
      var Output = $(this).attr('id');
      //alert(Output);
      if( Input == Output){
        $(this).show();
      }
      else {
        $(this).hide();
      }
      });
     });



    var ActiveTab = $(this).find('.accordianTab_label.tabActive').attr('data-filter-group-trigger');
    $('.accordian-groups-main').each(function(){
        var AccordianHeading = $(this).attr('data-filter-group');
        if (ActiveTab == AccordianHeading) {
          console.log(ActiveTab + '==' + AccordianHeading) 
          $(this).show();
        }
      });



   $(document).on('change keyup paste', '.faqAccordianBanner_search input#search', function(){
    // console.log('key');
    var searchtermNF = $(this).val();
    var searchTerm = $(this).val().toUpperCase();
    // console.log(searchTerm);
    if ( searchTerm == "" ) {
      $('.faqAccordianError_message').hide();
      $('.faqAccordian-groups-main').hide();
      return;
    }
    $(".faqAccordian-groups-main").each(function(){
      var accordianText = $(this).find('.Accordian-ingredient-wrapper .ingredient-block').text().toUpperCase();
      // console.log('accordian Text----' + accordianText)
      if  ( accordianText.indexOf(searchTerm) != -1) {
        $(this).show();
        $(this).addClass('searchMatched');
      }else{
        $(this).hide();
        $(this).removeClass('searchMatched');
      }

      var MatchedLength = $('.faqAccordian-groups-main.searchMatched').length;
      // console.log(MatchedLength)
      if(MatchedLength >= 1) {
        $('.faqAccordianError_message').hide();
      }else{
        $('.faqAccordianError_message span').text(searchtermNF);
        $('.faqAccordianError_message').show();
      }
    });
  });

  
  

    $(document).on('click', '#faqAccordian-header-scroll .faq-image-titleColumn', function(){
      $(this).addClass('tabActive').parent().siblings().find('.faq-image-titleColumn').removeClass('tabActive');
      var TabHeading = $(this).attr('data-filter-group-trigger');
      $('.faqAccordian-groups-main').each(function(){
        var accordianHeading = $(this).attr('data-filter-group');
        if (TabHeading == accordianHeading) {
          $(this).show();
          $('.faqAccordianError_message').hide();
        } else {
          $(this).hide();          
        }
      });
    });



  $(document).on('click', '#ingredientsAccordian-header-scroll .accordianTab_label', function(){
      $(this).addClass('tabActive').parent().siblings().find('.accordianTab_label').removeClass('tabActive');
      var TabHeading = $(this).attr('data-filter-group-trigger');
      $('.accordian-groups-main').each(function(){
        var accordianHeading = $(this).attr('data-filter-group');
        if (TabHeading == accordianHeading) {
          $(this).show();
        } else {
          $(this).hide();          
        }
      });
    });


  


  $(document).on('click', '.Accordian-ingredient-wrapper', function(){
      $(this).toggleClass('accordianActive').parents('.accordian-groups-ingredient').siblings().find('.Accordian-ingredient-wrapper').removeClass('accordianActive');
      $(this).siblings('.ingredient-content').slideToggle()
      $(this).parents('.accordian-groups-ingredient').siblings().find('.ingredient-content').slideUp();
    });



  let items = document.querySelector(".header__inline-menu").querySelectorAll("details");
  // console.log(items)
  items.forEach(item => {
    item.addEventListener("mouseover", () => {
      item.setAttribute("open", true);
      item.querySelector("ul").addEventListener("mouseleave", () => {
        item.removeAttribute("open");
      });
    item.addEventListener("mouseleave", () => {
      item.removeAttribute("open");
    });
  });
  
  });


  $(document).on('click', '.product_allIngredients_btn', function(e){
    e.preventDefault();
    $(this).siblings('#more-ingredients-list').slideToggle();
  });

  $(document).on('click', '.facet-filters.sortingNew .facetsSortBy_heading', function(){
    $(this).siblings('.select__select').fadeToggle();
    $(this).toggleClass('active');
  });

  // $(document).mouseup(function(e) {
  // var container = $('.facet-filters.sortingNew .select__select');
  // if (!container.is(e.target) && container.has(e.target).length === 0)
  // { 
  //   $('.facet-filters.sortingNew .select__select').fadeToggle();
  // }
  // });
  
});



$(document).ready(function(){
  var windowLocation = window.location.href.split("#")[1];
  console.log(windowLocation);
  if(windowLocation == '' || windowLocation == undefined){
    var dealsTab = $('.deals-page_wrapper .accordianTab_label.tabActive').attr('data-deals-filter');
    $('.tab-sectionMatch').each(function(){
      var tabSection = $(this).attr('data-tab-handle');
      if(dealsTab == tabSection){
        $(this).show();
      }else{
        $(this).hide(); 
      }      
    });
  }else{
    $('.deals-page_wrapper ul li .accordianTab_label').each(function(){
      var tab_Section = $(this).attr('data-deals-filter');
      if(windowLocation == tab_Section){
        $(this).addClass('tabActive');
      }else{
        $(this).removeClass('tabActive');
      }
    });
    $('.tab-sectionMatch').each(function(){
      var tabSection = $(this).attr('data-tab-handle');
      if(windowLocation == tabSection){
        $(this).show();
      }else{
        $(this).hide(); 
      }      
    });
  }
  
  
  $(document).on('click', '.deals-page_wrapper .accordianTab_label', function(){
    var tabLabelAccordian = $(this).attr('data-deals-filter');
    $('.tab-sectionMatch').each(function(){
      var tabSection = $(this).attr('data-tab-handle');
      if(tabLabelAccordian == tabSection){
        $(this).show();
      }else{
        $(this).hide(); 
      }      
    });
  });


  $(document).on('click', '.itg_notACustomer:not(.itg--register, .itg--login) .header__icon--account', function(e){
    e.preventDefault();
    $('body').addClass('overflow-hidden itg--popupOpen');
    $('.login-popup').show();
    $('.loginPopup_overlay').show();
  });


  $(document).on('click', '.login-popup .login.loginPage .loginPage_registerButton', function(e){
    e.preventDefault();
    $('.customer.login.loginPage').hide();
    $('.customer.register.registerPage').show();
  });

  $(document).on('click', '.login-popup .register.registerPage .registerPage_loginButton', function(e){
    e.preventDefault();
    $('.customer.register.registerPage').hide();
    $('.customer.login.loginPage').show();
  });


 /* $(document).mouseup(function(e) {
  if($('body').hasClass('itg--popupOpen')){
    var container = $('.login-popup__main');
    if (!container.is(e.target) && container.has(e.target).length === 0)
      { 
        $('body').removeClass('overflow-hidden itg--popupOpen');
        $('.login-popup').hide();
        $('.loginPopup_overlay').hide();
      }
    }
  }); */

  $(document).on('click', '.login-popup .loginPopupClose', function(e){
    e.preventDefault();
    $('body').removeClass('overflow-hidden itg--popupOpen');
    $('.login-popup').hide();
    $('.loginPopup_overlay').hide();
  });


  // var urlHref = window.location.href;
  // if(urlHref.indexOf('customer_posted=true') != -1){
  //   setTimeout(function(){
  //     $('body').addClass('overflow-hidden itg--newsletter_popupOpen');
  //     $('.newslettercouponPopup').show();
  //     $('.newsletterCouponOverlay').show();
  //   }, 2000);
  //   setTimeout(function(){
  //     $('body').removeClass('overflow-hidden itg--newsletter_popupOpen');
  //     $('.newslettercouponPopup').hide();
  //     $('.newsletterCouponOverlay').hide();
  //   }, 10000);
  // }

  
  // $(document).on('click', '.newslettercouponPopup .newslettercouponPopupClose', function(e){
  //   e.preventDefault();
  //   $('body').removeClass('overflow-hidden itg--newsletter_popupOpen');
  //   $('.newslettercouponPopup').hide();
  //   $('.newsletterCouponOverlay').hide();
  // });

  
  $('.thumbnail-list').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: false,
    arrows: true,
    vertical: true,
    infinite: false,
    prevArrow:"<button type='button' class='slick-prev pull-left'><svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='#000' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-down'><polyline points='6 9 12 15 18 9'></polyline></svg></button>",
    nextArrow:"<button type='button' class='slick-next pull-right'><svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='#000' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-up'><polyline points='18 15 12 9 6 15'></polyline></svg></button>",
    responsive: [
      {
        breakpoint: 990,
        settings: {
          vertical: false,
        }
      }
    ]
  });
  
  
  $('.thumbnail-list').on('afterChange', function(){
    if($('.thumbnail-list__item.thumnail-listLast').hasClass('slick-active')){
      $('.thumbnail-list').find('.slick-arrow.slick-prev').addClass('showArrow');
      $('.thumbnail-list').find('.slick-arrow.slick-next').addClass('hideArrow');
    }
    if($('.thumbnail-list__item.thumnail-listfirst').hasClass('slick-active')){
      $('.thumbnail-list').find('.slick-arrow.slick-prev').removeClass('showArrow');
      $('.thumbnail-list').find('.slick-arrow.slick-next').removeClass('hideArrow');
    }
  });

   /* var itg_popup_2 = $.cookie("itgv_newsletter");
    var subscriptionStorage = localStorage.getItem('brevo_newsletter');
    console.log(subscriptionStorage);

    setTimeout(function(){
      if(subscriptionStorage == 'subscribed') {
        
      }
      else if(itg_popup_2 == "newsletter__popup") {
        
      }
      else {
        $('.brevo-popup').fadeIn();
        $('body').addClass('overflow-hidden itg--brevo_popupOpen');
        $('.brevo-popup').show();
        $('.loginPopup_overlay').show();
      }
    }, 5000);
  
    $('#sib-form').submit(function (e) {
      e.preventDefault();
        var email = $(document).find('#sib-form #EMAIL').val();
           // if(email){
             
           // }else 
             if(IsEmail(email)==false){
             alert('Please enter valid email');
           }else if(IsEmail(email)==true){
           var form = $(this);
           var actionUrl = form.attr('action');
            $.ajax({
                type: "POST",
                url: actionUrl,
                data: form.serialize(),
                dataType: "json",
                timeout: 2000, 
                success:function(data){
                  // localstore set
                  
                  localStorage.setItem('brevo_newsletter', 'subscribed');
                  $('body').removeClass('overflow-hidden itg--brevo_popupOpen');
                  $('.brevo-popup').hide();
                  $('.loginPopup_overlay').hide();
                },error:function(err){
                  // localstore set
                  localStorage.setItem('brevo_newsletter', 'subscribed');
                  $('body').removeClass('overflow-hidden itg--brevo_popupOpen');
                  $('.brevo-popup').hide();
                  $('.loginPopup_overlay').hide();
                }
            });
          }else{
           return false;
          }

        function IsEmail(email) {
            var regex = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
            if(!regex.test(email)) {
               return false;
            }else{
               return true;
            }
        }
    });


  $(document).on('click', '.brevo-popup .loginPopupClose', function(e){
    e.preventDefault();
    $('body').removeClass('overflow-hidden itg--brevo_popupOpen');
    $('.brevo-popup').hide();
    $('.loginPopup_overlay').hide();
    
  });


  $(document).mouseup(function(e) {
  if($('body').hasClass('itg--brevo_popupOpen')){
    var container = $('.brevo-popup');
    if (!container.is(e.target) && container.has(e.target).length === 0)
      { 
        $('body').removeClass('overflow-hidden itg--brevo_popupOpen');
        $('.brevo-popup').hide();
        $('.loginPopup_overlay').hide();
        // var getExpireTime = {{ settings.announce_cookies }};
        var expDate = new Date();
        expDate.setTime(expDate.getTime() + (720 * 60 * 60 * 1000)); // add 15 minutes
        console.log(expDate);
        var itg_popup =  $.cookie("itgv_newsletter", "newsletter__popup", { path: '/', expires : expDate });
      }
    }
  });

  $(document).on('click', '.brevo-popup .loginPopupClose', function(e){
    $('body').removeClass('overflow-hidden itg--brevo_popupOpen');
    $('.brevo-popup').hide();
    $('.loginPopup_overlay').hide();
    // var getExpireTime = {{ settings.announce_cookies }};
    var expDate = new Date();
    expDate.setTime(expDate.getTime() + (720 * 60 * 60 * 1000)); // add 15 minutes
    console.log(expDate);
    var itg_popup =  $.cookie("itgv_newsletter", "newsletter__popup", { path: '/', expires : expDate });
  }); */

  // $(document).mouseup(function(e) {
  // if($('body').hasClass('itg--popupOpen')){
  //   var container = $('.brevo-popup');
  //   if (!container.is(e.target) && container.has(e.target).length === 0)
  //     { 
  //       $('.brevo-popup').hide();
  //       $('body').removeClass('overflow-hidden itg--popupOpen');
  //       $('.loginPopup_overlay').hide();
  //     }
  //   }
  // });


  if (window.matchMedia("(max-width: 749px)").matches) {
    $('.deals-page_wrapper #ingredientsAccordian-header-scroll .deals_AccordianSlide').slick({
      infinite: false,
      slidesToShow: 2,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      prevArrow:'<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M1.2002 6L7.2002 12L7.8002 11.4L2.4002 6L7.8002 0.6L7.2002 0L1.2002 6Z" fill="black"/><path d="M1.2002 6L7.2002 12L7.8002 11.4L2.4002 6L7.8002 0.6L7.2002 0L1.2002 6Z" fill="black" fill-opacity="0.2"/><path d="M1.2002 6L7.2002 12L7.8002 11.4L2.4002 6L7.8002 0.6L7.2002 0L1.2002 6Z" fill="black" fill-opacity="0.2"/><path d="M1.2002 6L7.2002 12L7.8002 11.4L2.4002 6L7.8002 0.6L7.2002 0L1.2002 6Z" fill="black" fill-opacity="0.2"/><path d="M1.2002 6L7.2002 12L7.8002 11.4L2.4002 6L7.8002 0.6L7.2002 0L1.2002 6Z" fill="black" fill-opacity="0.2"/><path d="M1.2002 6L7.2002 12L7.8002 11.4L2.4002 6L7.8002 0.6L7.2002 0L1.2002 6Z" fill="black" fill-opacity="0.2"/></svg></button>',
      nextArrow:'<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M10.7998 6L4.7998 12L4.1998 11.4L9.5998 6L4.1998 0.6L4.7998 0L10.7998 6Z" fill="white"/></svg></button>',
      responsive: [
        {
          breakpoint: 479,
          settings: {
            slidesToShow: 1.75,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 375,
          settings: {
            slidesToShow: 1.5,
            slidesToScroll: 1
          }
        }
      ]
    });



    $('.product__media-wrapper .product__media-list').slick({
      slidesToShow: 2,
      slidesToScroll: 1,
      autoplay: false,
      arrows: false,
      dots: true,
      infinite: false,
      prevArrow:"<button type='button' class='slick-prev pull-left'><svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='#000' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-down'><polyline points='6 9 12 15 18 9'></polyline></svg></button>",
      nextArrow:"<button type='button' class='slick-next pull-right'><svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='#000' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-up'><polyline points='18 15 12 9 6 15'></polyline></svg></button>"
    });

    
  }




  // function formValidation(){
		// 		var first_name = $('#RegisterForm-FirstName').val;
		// 			if(first_name == ""){
		// 				$('#RegisterForm-FirstName').siblings("err").innerHTML = "*Please fill this field";
  //                     alert(first_name)
		// 			}
		// 			else{
		// 				document.getElementById("err").innerHTML = "";
		// 			}

    //           var last_name = $('#RegisterForm-LastName').value;
				// 	if(last_name == ""){
				// 		document.getElementById("err").innerHTML = "*Please fill this field";
				// 	}
				// 	else{
				// 		document.getElementById("err").innerHTML = "";
				// 	}
    

				// var password = document.getElementById("pass").value;
				// var passwordLength = password.length;
				// 	if(passwordLength == ""){
				// 		document.getElementById("pas").innerHTML = "*Please fill this field";
				// 	}
				// 	else if(passwordLength <=5){
				// 		document.getElementById("pas").innerHTML = "*Enter min. 6 digits password";
				// 	}
				// 	else{
				// 		document.getElementById("pas").innerHTML = "";
				// 	}

		
    
				// var mail = $('#RegisterForm-email').value;
				// var valid = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
				// 	if(mail == ""){
				// 		document.getElementById("eml").innerHTML = "*Please fill this field";
				
				// 	return false;
				// }
				// 	else if(!(mail.match(valid))){
				// 		document.getElementById("eml").innerHTML = "Enter correct email";
				// }
				// 	else{
				// 		document.getElementById("eml").innerHTML = "";
				
				// }
				
			// }

  // $(document).on('click', '#itg--create_customer button', function(e){
  //   e.preventDefault();
  //   // formValidation();
  //   const form = document.getElementById('itg--create_customer');
  //   const data = new FormData(form);
  //   var customer = JSON.stringify(Object.fromEntries(data.entries()));
  //   var validEmail = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  //   customer = JSON.parse(customer);
  //   console.log(customer);
  //   // console.log(customer.first_name);
  //   var customerFirstName = customer.first_name;
  //   var customerLastName = customer.last_name;
  //   var customerEmail = customer.email;
  //   var customerPassword = customer.password;
  //   console.log(customerPassword)
  //   var customerPasswordLength = customerPassword.length;
    

  //   if(customerFirstName == ""){
  //     $('.RegisterForm-FirstName_field').addClass('errorBorder');
  //   }
  //   else{
  //     $('.RegisterForm-FirstName_field').removeClass('errorBorder');
  //   }

  //   if(customerLastName == ""){
  //     $('.RegisterForm-LastName_field').addClass('errorBorder');
  //   }
  //   else{
  //     $('.RegisterForm-LastName_field').removeClass('errorBorder');
  //   }

  //   if(customerEmail == ""){
  //     $('.RegisterForm-email_field').addClass('errorBorder');
  //     return false;
  //   }
  //   else if(!(customerEmail.match(validEmail))){
  //     $('.RegisterForm-email_field').addClass('errorBorder');
  //   }
  //   else{
  //     $('.RegisterForm-email_field').removeClass('errorBorder');
  //   }

  //   if(customerPassword == ""){
  //     $('.RegisterForm-password_field').addClass('errorBorder');
  //   }
  //   else if(customerPasswordLength <=5 ){
  //     $('.RegisterForm-password_field').addClass('errorBorder');
  //   }
  //   else{
  //     $('.RegisterForm-password_field').removeClass('errorBorder');
  //   }

    
  // });


  // $(".itg--create_customer").submit(function(e) {
  //      e.preventDefault();

  //      var otp = '';
  //      var form_data = new FormData();
  //      var fname = $(this).find('input[name="first_name"]').val();
  //      var lname = $(this).find('input[name="last_name"]').val();
  //      var email = $(this).find('input[name="email"]').val();
  //      var password = $(this).find('input[name="password"]').val();
  //      var otp = $(this).find('input[name="otp"]').val();

  //      form_data.append("fname", fname);
  //      form_data.append("lname", lname);
  //      form_data.append("email", email);
  //      form_data.append("password", password);
  //      form_data.append("otp", otp);

  //         $(document).find('.registerPage_loginButton_text').text('');
  //         $(document).find('.registerPage_loginButton_text').hide();
  //         $(document).find('#custom_loader').addClass('loading');
  //         $.ajax({
  //           type: 'POST',
  //           url: 'https://dev.shopifyexperthelp.com/app/project_app/botanity/get_customer.php',
  //           data:form_data,
  //           contentType: false,
  //           cache: false,
  //           processData:false,
  //           success: function(response){
  //             $(document).find('.registerPage_loginButton_text').text(response);
  //             $(document).find('.registerPage_loginButton_text').show();
  //             $(document).find('#custom_loader').removeClass('loading');
  //             if(response == 'Your account has been successfully created'){
  //               $('.itg--create_customer')[0].reset();
  //             }
  //           }
  //        });
  // });

 
   $(document).on('click', '#ac_nextButton', function(e){
         e.preventDefault();
         var otp = '';
         var fname = $(this).closest(".itg--create_customer").find('input[name="first_name"]').val();
         var lname = $(this).closest(".itg--create_customer").find('input[name="last_name"]').val();
         var email = $(this).closest(".itg--create_customer").find('input[name="email"]').val();
         var password = $(this).closest(".itg--create_customer").find('input[name="password"]').val();
         var otp = $(this).closest(".itg--create_customer").find('input[name="otp"]').val();

         var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
         var form_data = new FormData();
     
          $(".error_form").hide();
          if(fname == ''){
             $(this).closest(".itg--create_customer").find('.first_name').show();
             $(this).closest(".itg--create_customer").find('.first_name').text('This field is required');
          }else if(lname == ''){
            $(this).closest(".itg--create_customer").find('.last_name').show();
            $(this).closest(".itg--create_customer").find('.last_name').text('This field is required');
          }else if(email == ''){
             $(this).closest(".itg--create_customer").find('.first_email').show();
             $(this).closest(".itg--create_customer").find('.first_email').text('This field is required');
          }else if(!emailReg.test(email)){
            $(this).closest(".itg--create_customer").find('.first_email').show();
            $(this).closest(".itg--create_customer").find('.first_email').text('Enter a valid email');
          }else if(password == ''){
            $(this).closest(".itg--create_customer").find('.first_password').show();
            $(this).closest(".itg--create_customer").find('.first_password').text('This field is required');
          }else{
                 $(".error_form").hide();
                 form_data.append("fname", fname);
                 form_data.append("lname", lname);
                 form_data.append("email", email);
                 form_data.append("password", password);
                 form_data.append("otp", otp);
                  $(document).find('.registerPage_loginButton_text').text('');
                  $(document).find('.registerPage_loginButton_text').hide();
                  $(document).find('#custom_loader').addClass('loading');
                  $.ajax({
                    type: 'POST',
                    url: 'https://dev.shopifyexperthelp.com/app/project_app/botanity/get_customer.php',
                    data:form_data,
                    contentType: false,
                    cache: false,
                    processData:false,
                    success: function(response){
                      if(response == 'OTP sent to email'){
                         $(document).find('.RegisterForm-mainFields').hide();
                         $(document).find('.RegisterForm-otpFields').show();
                      }
                      $(document).find('.registerPage_loginButton_text').text(response);
                      $(document).find('.registerPage_loginButton_text').show();
                      $(document).find('#custom_loader').removeClass('loading');
                      if(response == 'Your account has been successfully created'){
                        $('.itg--create_customer')[0].reset();
                      }
                    }
                 });
            
          }
   });

   $(document).on('click', '#ac_submitButton', function(e){
         e.preventDefault();
         var otp = '';
         var fname = $(this).closest(".itg--create_customer").find('input[name="first_name"]').val();
         var lname = $(this).closest(".itg--create_customer").find('input[name="last_name"]').val();
         var email = $(this).closest(".itg--create_customer").find('input[name="email"]').val();
         var password = $(this).closest(".itg--create_customer").find('input[name="password"]').val();
         var otp = $(this).closest(".itg--create_customer").find('input[name="otp"]').val();

         var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
         var form_data = new FormData();
     
          $(".error_form").hide();
          if(fname == ''){
             $(this).closest(".itg--create_customer").find('.first_name').show();
             $(this).closest(".itg--create_customer").find('.first_name').text('This field is required');
          }else if(lname == ''){
            $(this).closest(".itg--create_customer").find('.last_name').show();
            $(this).closest(".itg--create_customer").find('.last_name').text('This field is required');
          }else if(email == ''){
             $(this).closest(".itg--create_customer").find('.first_email').show();
             $(this).closest(".itg--create_customer").find('.first_email').text('This field is required');
          }else if(!emailReg.test(email)){
            $(this).closest(".itg--create_customer").find('.first_email').show();
            $(this).closest(".itg--create_customer").find('.first_email').text('Enter a valid email');
          }else if(password == ''){
            $(this).closest(".itg--create_customer").find('.first_password').show();
            $(this).closest(".itg--create_customer").find('.first_password').text('This field is required');
          }else if(otp == ''){
              $(this).closest(".itg--create_customer").find('.otp_name').show();
              $(this).closest(".itg--create_customer").find('.otp_name').text('This field is required');
          }else{
                 $(".error_form").hide();
                 form_data.append("fname", fname);
                 form_data.append("lname", lname);
                 form_data.append("email", email);
                 form_data.append("password", password);
                 form_data.append("otp", otp);
                  $(document).find('.registerPage_loginButton_text').text('');
                  $(document).find('.registerPage_loginButton_text').hide();
                  $(document).find('#custom_loader').addClass('loading');
                  $.ajax({
                    type: 'POST',
                    url: 'https://dev.shopifyexperthelp.com/app/project_app/botanity/get_customer.php',
                    data:form_data,
                    contentType: false,
                    cache: false,
                    processData:false,
                    success: function(response){
                      $(document).find('.registerPage_loginButton_text').text(response);
                      $(document).find('.registerPage_loginButton_text').show();
                      $(document).find('#custom_loader').removeClass('loading');
                      if(response == 'Your account has been successfully created'){
                        window.location.href = "/account";
                        $('.itg--create_customer')[0].reset();
                      }
                    }
                 });
            
          }
   });



  $(document).on('click', '.product__info-container .rc-widget .rc-subscription-details .rc-subscription-details__button', function(){
    window.location.href = '/pages/subscribe-save';
  });

  
});
